import React, { useState } from 'react';
import CompanyProvidersTab from '../components/CompanyProvidersTab';
import InmobiliariasTab from '../components/InmobiliariasTab';

const CompanyProviders = () => {
  const [activeTab, setActiveTab] = useState('company-providers'); // 'company-providers' o 'inmobiliarias'

  return (
    <div className="px-6">
      <h2 className="text-2xl font-bold mb-4">Gestión de Patners Providers</h2>
      <p className="text-gray-600 mb-6">
        Administra los Patners Providers que gestionan respectivas propiedades.
      </p>

      {/* Sistema de Tabs */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('company-providers')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'company-providers'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              Company Providers
            </button>
            <button
              onClick={() => setActiveTab('inmobiliarias')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'inmobiliarias'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              Inmobiliarias
            </button>
          </nav>
        </div>
      </div>

      {/* Contenido de los tabs */}
      <div>
        {activeTab === 'company-providers' && <CompanyProvidersTab />}
        {activeTab === 'inmobiliarias' && <InmobiliariasTab />}
      </div>
    </div>
  );
};

export default CompanyProviders;
